import axios from 'axios';
import { CalculateSalariesAPIsConstants } from "./../enums/daily-movements/CalculateSalariesEnums";
import DownloadService from '@/core/services/DownloadService';

const CalculateSalariesModule = {
    namespaced: true,
    actions: {
        addItem({ commit }, { apiPath, credentials }) {
            return new Promise((resolve, reject) => {
                axios
                .post(`${apiPath}`, credentials)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
            });
        },
    }
}
export default CalculateSalariesModule;